export default __webpack_public_path__ + "static/villain-comics-9beeb3bbab9c0ec17ca3757f56e564ce.pdf";